import React, {useContext} from "react";
import {View, Text} from '@react-pdf/renderer';
import PropTypes from "prop-types";

import {PrintDocumentContext} from "./printDocumentContext";

const PrintDocumentSignature = (props) => {
  const {styles} = props;
  const printContext = useContext(PrintDocumentContext);

  return (
    <View style={styles.signature} wrap={false}>
      <View style={[styles.section, styles.sectionLeft]}>
        <Text style={styles.signatureText}>{printContext.messages["receipt.signature.name"]}</Text>
      </View>
      <View style={[styles.section, styles.sectionCenter]}>
        <Text style={styles.signatureText}>{printContext.messages["receipt.signature.date"]}</Text>
      </View>
      <View style={[styles.section, styles.sectionRight]}>
        <Text style={styles.signatureText}>{printContext.messages["receipt.signature.signature"]}</Text>
      </View>
    </View>
  )
};

PrintDocumentSignature.propTypes = {
  styles: PropTypes.object.isRequired,
};

export default PrintDocumentSignature
